import React from "react";
import COMPOSITE_INDEX_WHY_IMG_61 from "../../../../../../assets/img/composite-index-icon1.png";
import COMPOSITE_INDEX_WHY_IMG_59 from "../../../../../../assets/img/composite-index-icon2.png";
import COMPOSITE_INDEX_WHY_IMG_20 from "../../../../../../assets/img/matters-now-listing-icon2.png";
import COMPOSITE_INDEX_WHY_IMG_60 from "../../../../../../assets/img/composite-index-icon4.png";
import IMG_IMAGE_23 from "../../../../../../assets/img/matters-now-listing-icon1.png";
import IMG_IMAGE_20 from "../../../../../../assets/img/matters-now-listing-icon2.png";
import IMG_IMAGE_7 from "../../../../../../assets/img/matters-now-listing-icon3.png";
import IMG_IMAGE_21 from "../../../../../../assets/img/matters-now-listing-icon4.png";
import IMG_IMAGE_64 from "../../../../../../assets/img/yellow-magnifying-glass.png";
const IMG_VECTOR_1 = "http://localhost:3845/assets/a7ddf1339ea59a03466370ffabd555d12228f98e.svg";
/**
 * Presets for `<LeftCard data={...} />` — one component, tab-specific copy/icons/footer.
 * - `whatMattersNow` — MCP `1:4714`…`1:4758`
 * - `whatMattersToMe` — MCP `1:6268`…`1:6302`
 * - `whatStillMatters` — MCP `1:5511`…`190:5927`
 * - `compositeIndex` — MCP `1:4464`…`1:4514` (inner frame; same structure as `1:4714` left card)
 */
export const leftCardData = {
    whatMattersNow: {
        title: "What Matters Now!",
        headline: "Executive-Level Intelligence You Can Rely On",
        description: "Roda BI continuously monitors financial and care risk across your organization, ensuring critical issues are identified and managed in real time.",
        rows: [
            {
                id: "r1",
                variant: 1,
                imageSrc: IMG_IMAGE_23,
                text: "Sophisticated, cross-organizational monitoring.",
            },
            {
                id: "r2",
                variant: 2,
                imageSrc: IMG_IMAGE_20,
                text: "Proactive, data-driven decision support.",
            },
            {
                id: "r3",
                variant: 3,
                imageSrc: IMG_IMAGE_7,
                text: "Fast response to emerging threats and breaches.",
            },
            {
                id: "r4",
                variant: 4,
                imageSrc: IMG_IMAGE_21,
                text: "Empowering strategic leadership with actionable insights.",
            },
        ],
        footerLabels: [
            "Real-Time Monitoring",
            "Critical Updates",
            "Governance Insight",
        ],
    },
    whatMattersToMe: {
        title: "What Matters to Me",
        headline: "Focused on Your Role. Nothing Else.",
        description: "Role BI allows you to define what matters to you— so the metrics, risks, and signals relevant to your role always visible.",
        rows: [
            {
                id: "wmtm-r1",
                variant: 1,
                imageSrc: IMG_IMAGE_23,
                text: "No searching. No scrolling.",
            },
            {
                id: "wmtm-r2",
                variant: 2,
                imageSrc: IMG_IMAGE_20,
                text: React.createElement(React.Fragment, null, "Your Single Source of Operational Truth"),
                subtext: "Custom-built by you, for you.",
            },
            {
                id: "wmtm-r3",
                variant: 2,
                imageSrc: IMG_IMAGE_64,
                text: "Everything you need to see.",
                subtext: "Nothing you need to search for.",
            },
            {
                id: "wmtm-r4",
                variant: 4,
                imageSrc: IMG_IMAGE_21,
                text: "Your Single Source of Operational Truth",
                subtext: "Everything you need to see.",
            },
        ],
    },
    whatStillMatters: {
        title: "What Still Matters",
        headline: "Protecting long-term performance and trust",
        description: "No critical issue is ignored or forgotten. Ensuring sustained attention and follow-through.",
        rows: [
            {
                id: "wsm-r1",
                variant: 1,
                imageSrc: IMG_IMAGE_23,
                text: "Tracking unresolved critical issues",
                subtext: "Custom-built by you, for you",
            },
            {
                id: "wsm-r2",
                variant: 2,
                imageSrc: IMG_IMAGE_20,
                text: "Issues remain in view until resolved",
                subtext: "Keeping them from fading out of sight",
            },
            {
                id: "wsm-r3",
                variant: 3,
                imageSrc: IMG_IMAGE_7,
                overlaySrc: IMG_VECTOR_1,
                text: "Escalating over time as needed",
                subtext: "Reflecting urgency and importance",
            },
            {
                id: "wsm-r4",
                variant: 4,
                imageSrc: IMG_IMAGE_64,
                text: "Your single source of operational truth",
                subtext: "Everything you need to see",
            },
        ],
        footerLabels: [
            "No Critical Issue is Forgotten",
            "No Breach is Overlooked",
            "No Responsibility Escapes",
        ],
    },
    compositeIndex: {
        title: "Composite Index",
        headline: "Focused on Your Role. Nothing Else.",
        description: "Role BI allows you to define what matters to you— so the metrics, risks, and signals relevant to your role always visible.",
        rows: [
            {
                id: "ci-r1",
                variant: 1,
                imageSrc: COMPOSITE_INDEX_WHY_IMG_61,
                thumbFrameClass: "left-card__thumb--ci-61",
                thumbImgClass: "left-card__thumb-img--ci-61",
                text: "Weighted Institutional Score",
                subtext: "Facility revenue, staffing, registered census",
            },
            {
                id: "ci-r2",
                variant: 2,
                imageSrc: COMPOSITE_INDEX_WHY_IMG_59,
                thumbFrameClass: "left-card__thumb--ci-59",
                thumbImgClass: "left-card__thumb-img--ci-59",
                text: "Forward-Looking Intelligence",
                subtext: "Key risk predictive outlook",
            },
            {
                id: "ci-r3",
                variant: 2,
                imageSrc: COMPOSITE_INDEX_WHY_IMG_20,
                text: "Inspection Readiness Score",
                subtext: "Regulatory survey preparedness",
            },
            {
                id: "ci-r4",
                variant: 4,
                imageSrc: COMPOSITE_INDEX_WHY_IMG_60,
                thumbFrameClass: "left-card__thumb--ci-60",
                thumbImgClass: "left-card__thumb-img--ci-60",
                text: "Your Homes at a Glance",
                subtext: "Administrative (dept), Financial (metrics) Operational (inspection)",
            },
        ],
        footerSlot: (React.createElement("div", { className: "left-card__ci-footer" },
            React.createElement("div", { className: "left-card__ci-pills-wrap", "data-node-id": "1:4497" },
                React.createElement("div", { className: "left-card__ci-pills-row", "data-node-id": "1:4498" },
                    React.createElement("div", { className: "left-card__ci-pill left-card__ci-pill--prime", "data-node-id": "1:4499", "data-name": "Background+Border" },
                        React.createElement("div", { className: "left-card__ci-pill-text-wrap", "data-node-id": "1:4500" },
                            React.createElement("p", { className: "left-card__ci-pill-text" }, "Prime"))),
                    React.createElement("div", { className: "left-card__ci-pill left-card__ci-pill--good", "data-node-id": "1:4501", "data-name": "Background+Border" },
                        React.createElement("div", { className: "left-card__ci-pill-text-wrap", "data-node-id": "1:4502" },
                            React.createElement("p", { className: "left-card__ci-pill-text" }, "Good"))),
                    React.createElement("div", { className: "left-card__ci-pill left-card__ci-pill--stress", "data-name": "Background+Border" },
                        React.createElement("div", { className: "left-card__ci-pill-text-wrap" },
                            React.createElement("p", { className: "left-card__ci-pill-text" }, "Stress")))),
                React.createElement("div", { className: "left-card__ci-pills-row", "data-node-id": "1:4503" },
                    React.createElement("div", { className: "left-card__ci-pill left-card__ci-pill--moderate", "data-node-id": "1:4504", "data-name": "Background+Border" },
                        React.createElement("div", { className: "left-card__ci-pill-text-wrap", "data-node-id": "1:4505" },
                            React.createElement("p", { className: "left-card__ci-pill-text" }, "High risk"))),
                    React.createElement("div", { className: "left-card__ci-pill left-card__ci-pill--severe-risk", "data-name": "Background+Border" },
                        React.createElement("div", { className: "left-card__ci-pill-text-wrap" },
                            React.createElement("p", { className: "left-card__ci-pill-text" }, "Severe risk"))),
                    React.createElement("div", { className: "left-card__ci-pill left-card__ci-pill--default", "data-node-id": "1:4506", "data-name": "Background+Border" },
                        React.createElement("div", { className: "left-card__ci-pill-text-wrap", "data-node-id": "1:4507" },
                            React.createElement("p", { className: "left-card__ci-pill-text" }, "Failure"))))),
            React.createElement("div", { className: "left-card__ci-bullets", "data-node-id": "1:4508" },
                React.createElement("div", { className: "left-card__ci-bullet-line", "data-node-id": "1:4509" },
                    React.createElement("p", { className: "left-card__ci-bullet-p" }, "\u2022 NO CRITICAL ISSUE IS FORGOTTEN | NO BRANCH IS OVERLOOKED")),
                React.createElement("div", { className: "left-card__ci-bullet-line", "data-node-id": "1:4510" },
                    React.createElement("p", { className: "left-card__ci-bullet-p" }, "\u2022 NO RESPONSIBILITY ESCAPES."))))),
    },
};
/** Same as `leftCardData.whatMattersNow` — re-export for call sites that only need this preset. */
export const mattersNowWhy = leftCardData.whatMattersNow;
